import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';

import { Container } from './styles';

import { DeleteButton, EditButton } from '../ActionButtons';

const useStyles = makeStyles({
  root: {
    width: '100%',
    margin: 'auto'
  },
  tableWrapper: {
    maxHeight: 407,
    overflow: 'auto'
  }
});

export default function CustomTable(props) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const { data, handleEdit, handleDelete, columns } = props;

  const classes = useStyles();

  function formatValue(value) {
    if (value === 'invalid') return 'Inválido';
    if (value === 'valid') return 'Válido';
    if (value === true) return 'Si';
    if (value === false) return 'No';
    return value;
  }

  function handleChangePage(event, newPage) {
    setPage(newPage);
  }

  function handleChangeRowsPerPage(event) {
    setRowsPerPage(+event.target.value);
    setPage(0);
  }

  function handleOnEditClick(data) {
    handleEdit(data);
  }

  function handleOnDeleteClick({ id }) {
    handleDelete(id);
  }

  return (
    <Container>
      <Paper className={classes.root}>
        {data && (
          <div data-testid="table">
            <div className={classes.tableWrapper}>
              <Table stickyHeader data-testid="table-component">
                <TableHead data-testid="table-header">
                  <TableRow>
                    {columns.map(column => (
                      <TableCell
                        data-testid="table-column"
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                      >
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>

                <TableBody>
                  {data
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map(row => {
                      return (
                        <TableRow
                          data-testid="table-row"
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={row.id}
                        >
                          {columns.map(column =>
                            column.id === 'actions' ? (
                              <TableCell key={column.id}>
                                {handleDelete && (
                                  <DeleteButton
                                    onClick={() => handleOnDeleteClick(row)}
                                  />
                                )}
                                {handleEdit && (
                                  <EditButton
                                    onClick={() => handleOnEditClick(row)}
                                  />
                                )}
                              </TableCell>
                            ) : (
                              <TableCell key={column.id} align={column.align}>
                                {formatValue(row[column.id])}
                              </TableCell>
                            )
                          )}
                        </TableRow>
                      );
                    })}
                </TableBody>
              </Table>
            </div>
            <TablePagination
              data-testid="table-navigation"
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={data.length}
              rowsPerPage={rowsPerPage}
              page={page}
              backIconButtonProps={{
                'aria-label': 'previous page'
              }}
              nextIconButtonProps={{
                'aria-label': 'next page'
              }}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </div>
        )}
      </Paper>
    </Container>
  );
}

CustomTable.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array,
  handleEdit: PropTypes.func,
  handleDelete: PropTypes.func
};
